<template>
  <b-card
      title="مدیریت لینک ها"
  >
    <b-row>
      <b-col
          class="table-size"
      >
        <div class="custom-search">
          <b-row>
            <div class="filter-row">
              <b-button
                  class="mb-1 mr-auto ml-1"
                  variant="primary"
                  @click="showModal()"
              >
                جدید
              </b-button>
              <b-col md="2">
                <b-form-group
                    label="عنوان"
                    label-for="Title"
                >
                  <b-form-input
                      v-model="filterOptions.Title"
                      @keyup.enter="update(1)"
                  />
                </b-form-group>
              </b-col>
              <b-col md="2">
                <b-form-group
                    label="لینک"
                    label-for="Url"
                >
                  <b-form-input
                      v-model="filterOptions.Url"
                      @keyup.enter="update(1)"
                  />
                </b-form-group>
              </b-col>
              <b-col md="2">
                <b-form-group
                    label="از تاریخ"
                    label-for="FromDate"
                >
                  <date-picker
                      v-model="filterOptions.FromDate"
                      placeholder=""
                  />
                </b-form-group>
              </b-col>
              <b-col md="2">
                <b-form-group
                    label="تا تاریخ"
                    label-for="FromDate"
                >
                  <date-picker
                      v-model="filterOptions.ToDate"
                      placeholder=""
                  />
                </b-form-group>
              </b-col>
              <b-button
                  v-ripple.400="'rgba(186, 191, 199, 0.15)'"
                  class="mb-1 mr-1"
                  variant="warning"
                  @click="update(1)"
              >فیلتر
              </b-button>
            </div>
          </b-row>
        </div>

        <b-table
            bordered
            hover
            striped
            :items="items"
            :fields="fields"
            class="mt-1 mb-2 position-relative"
            responsive
            :busy="loading"
        >
          <template #cell(Id)="data">
            <b-link
                @click="showModal(data.item)"
                class="font-weight-bold"
            >
              #{{ data.value }}
            </b-link>
          </template>

          <template #cell(Code)="data">
            {{ 'zi3.ir/' + data.value }}
          </template>

          <template #cell(actions)="data">

            <div
                class="text-nowrap"
            >
              <feather-icon
                  icon="CopyIcon"
                  size="16"
                  class="cursor-pointer"
                  @click="copy(data.item.Code)"
                  v-b-tooltip.click.focus.v-dark
                  title="کپی شد"
                  :id="data.item.Code"
              />

              <b-link
                  :href="'https://zi3.ir/' + data.item.Code"
                  target='_blank'
              >
              <feather-icon
                  icon="NavigationIcon"
                  size="16"
                  class="ml-1"
              />
              </b-link>

                <feather-icon
                    :id="`invoice-row-${data.item.Id}-send-icon`"
                    icon="EditIcon"
                    size="16"
                    class="ml-1 cursor-pointer"
                    @click="showModal(data.item)"
                />

              <feather-icon
                  icon="TrashIcon"
                  size="16"
                  class="ml-1 cursor-pointer"
                  @click="remove(data.item.Id)"
              />
            </div>
          </template>

          <template #table-busy>
            <div
                class="text-center my-2"
            >
              <b-spinner
                  variant="primary"
                  class="align-middle"
              />
              <strong class="ml-1">در حال دریافت اطلاعات ...</strong>
            </div>
          </template>

        </b-table>

        <z-pagination
            :page="filterOptions.Page"
            :total-rows="totalRows"
            :loading="loading"
            @change="update"
        />

      </b-col>

    </b-row>

    <b-modal
        v-model="isShow"
        ok-title="ذخیره"
        cancel-title="انصراف"
        cancel-variant="outline-secondary"
        centered
        title="جزپیات لینک"
        :no-close-on-backdrop="true"
        size="sm"
        @ok="save"
    >
        <b-col cols="12">
          <b-form-group
              label="عنوان"
              label-for="Title"
          >
            <b-form-input
                v-model="Form.Title"
                autocomplete="off"
            />
          </b-form-group>
        </b-col>

        <b-col cols="12">
          <b-form-group
              label="لینک"
              label-for="Url"
          >
            <b-form-input
                v-model="Form.Url"
                autocomplete="off"
            />
          </b-form-group>
        </b-col>
    </b-modal>
  </b-card>
</template>

<script>

import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'

export default {
  name: 'ShortUrl',
  components: {
    ToastificationContent,
  },
  data() {
    return {
      totalRows: 1000 * 1000,
      loading: false,
      filterOptions: {
        Title: null,
        Url: null,
        Page: 1,
        IsDesc: true,
        FromDate: this.$moment().startOf('jMonth').format('YYYY/MM/DD'),
        ToDate: this.$moment().endOf('jMonth').format('YYYY/MM/DD'),
      },
      isShow: false,
      Form: {},
      fields: [
        {
          key: 'Id',
          label: '#',
          thClass: 'col-width-50',
        },

        {
          key: 'Title',
          label: 'عنوان',
        },
        {
          key: 'Url',
          label: 'لینک',
        },
        {
          key: 'Code',
          label: 'لینک کوتاه',
        },
        {
          key: 'Visit',
          label: 'بازدید',
        },
        {
          key: 'actions',
          label: '',
          thClass: 'col-width-50',
        },
      ],
      items: [],
    }
  },
  created() {
    if (this.$store.state.zirehState.listFilter[this.$options.name]) {
      this.filterOptions = this.$store.state.zirehState.listFilter[this.$options.name]
    }
    this.update()
  },
  methods: {
    update(pageNumber) {
      this.loading = true

      this.filterOptions.Page = pageNumber || this.filterOptions.Page

      this.$store.commit('zirehState/setListFilter', { key: this.$options.name, value: this.filterOptions })

      this.$http.post(
          this.$api.shorturl.getlist, this.filterOptions,
      )
          .then(res => {
            this.totalRows = res.totalRow
            this.items = res.data
          })
          .finally(() => {
            this.loading = false
          })
    },
    remove(id) {
      this.removeRow(this.$api.shorturl.remove, 'Id', id)
    },
    save() {
      let url = this.$api.shorturl.add
      if (this.Form.Id) {
        url = this.$api.shorturl.update
      }

      this.loading = true
      this.$http.post(
          url, this.Form,
      )
          .then(() => {
            this.update()
          }).finally(() => {
        this.loading = false
      })
    },
    showModal(item) {
      this.isShow = true
      if (item){
        this.Form = JSON.parse(JSON.stringify(item))
      }else {
        this.Form = { Title: null, Id: null, Url: null }
      }
    },
    copy(code) {
      this.$copyText('zi3.ir/' + code)
      setTimeout(() => {
        this.$root.$emit('bv::hide::tooltip', code)
      }, 1000)
    },
  },
}
</script>
